import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import baseUrl from '../baseurl'

const _ = require('lodash')

export default {
  actions: {
    getPotatoSamplesData({
      commit,
      state
    }, data) {

      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/sampleinfo/${data.docId}/${data.sampleNo}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            await commit('updatePotatoSampleData', {
              ...data,
              content: resp.data.data
            })
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    getPotatoSamplesThreshold({
      commit,
      state
    }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/sampleinfo/${data.docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            await commit('updatePotatoSampleThreshold', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    savePotatoSampleInfo({
      state,
      commit
    }, {
      docId,
      sampleNo,
      sample
    }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/potato/sampleinfo/${docId}/${sampleNo}`;
        Axios.put(url, sample, config)
          .then(resp => {
            if (resp.data.error) {
              if(resp.data.msg)
              for(let key in resp.data.msg[0]){
                throw resp.data.msg[0][key] + " in " + key
              }
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getPotatoSummary({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/summary/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getPotatoSummary', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    ConfirmPotatoReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/potato/report/${docId}/confirm`;
        Axios.put(url, {}, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    ApprovePotatoReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/potato/report/${docId}/approve`;
        Axios.put(url, {}, config).then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getPotatoReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/report/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getPotatoSummary', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    deletePotatoReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/report/${docId}`
        if (!docId)
          return resolve()
        Axios.delete(url, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getPotatoComment({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/comment/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getPotatoComment', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    postPotatoComment({
      state,
      commit
    }, {
      docId,
      data
    }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/potato/comment/${docId}`
        Axios.post(url, data, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('postPotatoComment', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
  },
  mutations: {
    updatePotatoSampleData(state, data) {
      return new Promise(async (res, rej) => {
        if (state.sampleStateData[data.sampleNo - 1]) {
          state.sampleStateData[data.sampleNo - 1] = _.cloneDeep(data.content)
        } else if (!state.sampleStateData[data.sampleNo - 1]) {
          for (let i = state.sampleStateData.length; i < data.sampleNo; i++) state.sampleStateData.push({})
          state.sampleStateData.push(_.cloneDeep(data.content))
        }
        // let l = data.sampleNo - 1
        // let range = state.sampleStateData[l].sizeDesignation.sizeRange
        // if (range != '') {
        //   let unit = state.sampleStateData[l].sizeDesignation.unit
        //   let sizeData = state.sampleThresholds.sizeDesignation[unit][range]

        //   state.sampleStateData[l].sizeDesignation = {
        //     ...sizeData,
        //     ...state.sampleStateData[l].sizeDesignation

        //   }
        // }
        // for (let key in state.sampleStateData[l].defects) {
        //   state.sampleStateData[l].defects[key] = {
        //     ...state.sampleThresholds.defects.defects[key],
        //     ...state.sampleStateData[l].defects[key]
        //   }
        // }
        // for (let key in state.sampleStateData[l].allowance) {
        //   state.sampleStateData[l].allowance[key] = {
        //     ...state.sampleThresholds.allowance.values[key],
        //     ...state.sampleStateData[l].allowance[key]
        //   }
        // }
        res()

      })
    },
    updatePotatoSampleThreshold(state, data) {
      state.sampleThresholds = data
    },
    getPotatoSummary(state, data) {
      state.reports = _.cloneDeep(data)
    },
    getPotatoComment(state, data) {
      state.reportComments = data.reverse()
    },
    postPotatoComment(state, data) {
      state.reportComments = [data, ...state.reportComments]
    },
  }
}